/*
 * Copyright (C) 2021 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

export const DHtmlElementState = {
	NO_POINTER_EVENTS: "NO_POINTER_EVENTS"
};
